<app-navigation-header title="Reports" i18n-title="@@reports-reportsTitle">
	<div [appBreadcrumbLabel]="breadcrumbLabel">
		<app-cards>
			<div class="content-container">
				<div class="border-bottom">
					<p class="report-title" i18n="@@reports-runAReport">Run a Report</p>
				</div>

				<div class="inside-content-container">
					<div class="border-bottom">
						<ng-container>
							<div class="row capability-row">
								<div class="column">
									<div class="row">
										<h3><b i18n="@@reports-accessReport">Access Report</b></h3>
									</div>
									<p i18n="@@reports-accessReportMessage">
										All device accesses for your company and any company to whom you have granted access.
									</p>
									@if (hasAccessReportExport) {
										<div class="access-report-export" data-automation-id="reports-access-report-export">
											@switch (accessReportExport?.status) {
												@case ('waiting') {
													<span i18n="@@reports-accessReportExportWaiting">
														We have queued your report export. You can leave and come back when it is ready. Your
														download will remain on your "Reports" page for {{ accessReportExport?.companyName }} for 24
														hours, or until you start another export.
													</span>
												}
												@case ('preparing') {
													<span i18n="@@reports-accessReportExportPreparing">
														Your export is being prepared. You can leave and come back when it is ready. Your download
														will remain on your "Reports" page for {{ accessReportExport?.companyName }} for 24 hours,
														or until you start another export.
													</span>
												}
												@case ('ready') {
													<span i18n="@@reports-accessReportExportReady">
														Your export is ready. Available to download for 24 hours. A new export will replace this
														one.
													</span>
												}
												@case ('failed') {
													<span i18n="@@reports-accessReportExportFailed">
														Your export failed and was not saved. Open the report and click Start Export to start a new
														one.
													</span>
												}
											}
											@if (accessReportExport?.status === 'failed') {
												<button
													mat-stroked-button
													type="button"
													class="access-report-export-link"
													data-automation-id="reports-access-report-export-link"
													(click)="onAccessReportExportClicked()"
													i18n="@@reports-accessReportExportFailedLink"
												>
													View report
												</button>
											} @else {
												<button
													mat-stroked-button
													type="button"
													class="access-report-export-link"
													data-automation-id="reports-access-report-export-link"
													(click)="onAccessReportExportClicked()"
													i18n="@@reports-accessReportExportLink"
												>
													View export
												</button>
											}
										</div>
									}
								</div>

								<button
									mat-button
									style="height: 40px"
									class="primary-button"
									(click)="onAccessReportClicked()"
									i18n="@@reports-accessReportRunReport"
									data-automation-id="run-access-report-button"
								>
									Run Report
								</button>
							</div>
						</ng-container>
					</div>

					<div class="border-bottom">
						<ng-container>
							<div class="row capability-row">
								<div class="column">
									<div class="row">
										<h3><b i18n="@@reports-codeGenReport">Code Gen Report</b></h3>
									</div>
									<p i18n="@@reports-codeGenReportMessage">
										All codes that have been generated for devices for your company and any company to whom you have
										granted access.
									</p>
								</div>

								<button
									mat-button
									style="height: 40px"
									class="primary-button"
									(click)="onCodeGenReportClicked()"
									i18n="@@report-codeGenRunReport"
									data-automation-id="run-code-gen-report-button"
								>
									Run Report
								</button>
							</div>
						</ng-container>
					</div>
					<div class="border-bottom">
						<ng-container>
							<div class="row capability-row">
								<div class="column">
									<div class="row">
										<h3><b i18n="@@reports-InventoryReport">Inventory Report</b></h3>
									</div>
									<p i18n="@@reports-inventoryReportMessage">
										All devices owned by your company, as well as their status.
									</p>
								</div>

								<button
									mat-button
									style="height: 40px"
									class="primary-button"
									(click)="onInventoryReportClicked()"
									i18n="@@report-deviceRunReport"
									data-automation-id="run-inventory-report-button"
								>
									Run Report
								</button>
							</div>
						</ng-container>
					</div>

					<div class="border-bottom">
						<ng-container>
							<div class="row capability-row">
								<div class="column">
									<div class="row">
										<h3><b i18n="@@reports-UsageReport">Usage Report</b></h3>
									</div>
									<p i18n="@@reports-UsageReportMessage">
										Shows each company's total lockboxes and total accesses during a selected time period.
									</p>
								</div>
								<button
									mat-button
									style="height: 40px"
									class="primary-button"
									(click)="onUsageReportClicked()"
									i18n="@@report-UsageReport"
									data-automation-id="run-usage-report-button"
								>
									Run Report
								</button>
							</div>
						</ng-container>
					</div>

					<div class="border-bottom">
						<ng-container>
							<div class="row capability-row">
								<div class="column">
									<div class="row">
										<h3><b i18n="@@reports-PropertyReport">Property Report</b></h3>
									</div>
									<p i18n="@@reports-PropertyReportMessage">
										All properties that you own and shows if they are ready for removal.
									</p>
								</div>
								<button
									mat-button
									style="height: 40px"
									class="primary-button"
									(click)="onPropertyReportClicked()"
									i18n="@@report-UsageReport"
									data-automation-id="run-property-report-button"
								>
									Run Report
								</button>
							</div>
						</ng-container>
					</div>

					<div class="border-bottom">
						<ng-container>
							<div class="row capability-row">
								<div class="column">
									<div class="row">
										<h3><b i18n="@@reports-AlertReport">Alert Report</b></h3>
									</div>
									<p i18n="@@reports-AlertReportMessage">
										Shows you the alerts that have occurred for devices your company can access.
									</p>
								</div>
								<button
									mat-button
									style="height: 40px"
									class="primary-button"
									(click)="onAlertReportClicked()"
									i18n="@@report-AlertReport"
									data-automation-id="run-alert-report-button"
								>
									Run Report
								</button>
							</div>
						</ng-container>
					</div>

					@if (isKeyDetectionCompanySettingEnabled) {
						<div class="border-bottom">
							<ng-container>
								<div class="row capability-row">
									<div class="column">
										<div class="row">
											<h3><b i18n="@@reports-keyDetectionReport">Key Detection Report</b></h3>
										</div>
										<p i18n="@@reports-keyDetectionReportMessage">
											Shows the key detection status of every visit from someone at your company or any other company
											who has access.
										</p>
									</div>
									<button
										mat-button
										style="height: 40px"
										class="primary-button"
										(click)="onKeyDetectionReportClicked()"
										i18n="@@reports-accessReportRunReport"
										data-automation-id="run-key-detection-report-button"
									>
										Run Report
									</button>
								</div>
							</ng-container>
						</div>
					}
				</div>
			</div>
		</app-cards>
	</div>
</app-navigation-header>
